import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Order } from '@compumark/order-management-client';

import { FreetextDialogComponent } from './freetext-dialog/freetext-dialog.component';

@Component({
  selector: 'app-freetext-renderer',
  templateUrl: './freetext-renderer.component.html',
  styleUrls: ['./freetext-renderer.component.scss'],
  standalone: false,
})
export class FreetextRendererComponent implements ICellRendererAngularComp {
  private dialog = inject(MatDialog);

  public freeText?: string;
  private order!: Order;

  refresh(): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.freeText = params.value;
    this.order = params.data;
  }

  checkOverflow(element: any): boolean {
    return (
      element.offsetHeight < element.scrollHeight ||
      element.offsetWidth < element.scrollWidth
    );
  }

  openViewAllTextDialog(): void {
    this.dialog.open(FreetextDialogComponent, {
      data: {
        trademarkName: this.order.trademarkName,
        freeText: this.freeText,
      },
      width: '25vw',
      height: '100%',
      position: { right: '0' },
    });
  }
}
